import { Box, Checkbox, FormControlLabel } from "@mui/material";
import Text from "../../../../components/ui/Text";

export const CancellationPolicyBlock = ({
  agreedToTerms,
  setAgreedToTerms,
  refundCutoffHours,
  sx = {},
}) => {
  return (
    <Box sx={sx}>
      <Box
        sx={{
          p: 2,
          backgroundColor: "#D2F0FF",
          border: "1px solid #54B2FF",
          borderRadius: "6px",
        }}
      >
        <Text variant="paragraph">Cancellation policy</Text>
        <Box sx={{ mt: 1 }}>
          <Text variant="paragraph3" sx={{ color: "#666" }}>
            {refundCutoffHours ? (
              <>
                You can cancel up to{" "}
                <strong>
                  {refundCutoffHours} hours before the game starts
                </strong>{" "}
                for a<strong>full refund in game credits</strong>. Credits are
                non-transferable and cannot be exchanged for cash.
              </>
            ) : (
              <>
                You can not get a refund after booking. Please make sure you can
                attend before confirming your booking.
              </>
            )}
          </Text>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "flex-start", mt: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
              sx={{
                color: "#1890FF",
                "&.Mui-checked": {
                  color: "#1890FF",
                },
              }}
            />
          }
          label={null}
          sx={{ mr: 0 }}
        />
        <Text component="p" variant="paragraph3" sx={{ mt: "10px" }}>
          I have read and agree to the <b>cancellation policy</b>.
        </Text>
      </Box>
    </Box>
  );
};
